import { Component, ComponentInterface, Element, h, Host, JSX, Prop } from '@stencil/core';
import { Ratio } from './ratio';

const TARGET_CSS_CLASS = 'wb-aspect-ratio__target';

@Component({
  tag: 'wb-aspect-ratio',
  styleUrl: 'aspect-ratio.scss',
  shadow: false,
})
export class AspectRatioComponent implements ComponentInterface {
  @Element()
  public el: HTMLElement;

  /** aspect ratio */
  @Prop({ reflect: true })
  public ratio!: Ratio;

  public connectedCallback(): void {
    // note: this can select both `img`, `picture > img` , or other contents
    const targetEl = this.el.querySelector<HTMLElement>('img') || (this.el.firstElementChild as HTMLElement);
    targetEl.classList.add(TARGET_CSS_CLASS);
  }

  public render(): JSX.Element {
    return (
      <Host>
        <div class="wb-aspect-ratio__height-controller">
          <slot />
        </div>
      </Host>
    );
  }
}
